<template>
  <div>
    <documents-list />
  </div>
</template>
<script>
import documentsList from "@/components/CompanySetups/documentsSetups/documentsList";
export  default  {
  name: "documentsSetup",
  components:{
    documentsList
  }
}
</script>